import React from 'react'
import { useTheme } from '@/contexts/ThemeContext'
import { useTar } from '@/modules'
import { Button } from '@duck/ui'
import { useSidebar } from '@duck/ui'

interface ThemeSelectorProps {
  className?: string
}

export const ThemeSelector: React.FC<ThemeSelectorProps> = ({ className = '' }) => {
  const { setTheme, isDark } = useTheme()
  const { t } = useTar()
  const { open } = useSidebar()

  const handleToggleTheme = () => {
    setTheme(isDark ? 'light' : 'dark')
  }

  return (
    <Button
      onClick={handleToggleTheme}
      variant="ghost"
      size="sm"
      className={`hover:bg-accent/10 hover:text-foreground w-full text-muted-foreground justify-start`}
      title={isDark ? t('themes.light') : t('themes.dark')}
    >
      {!isDark ? (
        // Sun icon for switching to light mode
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      ) : (
        // Moon icon for switching to dark mode
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
        </svg>
      )}
      {open && (
        <span className="text-xs px-2">{!isDark ? t('themes.lightMode') : t('themes.darkMode')}</span>
      )}
    </Button>
  )
}
